import Locale from "../locales";

export const fetchFirebaseErrorMessage = (firebaseMessage) => {
  let message = "";

  switch (firebaseMessage) {
    case "Firebase: Error (auth/wrong-password).":
      message = Locale.t(
        "invalid_credentials_check_again_your_Email_And_Password",
      );
      break;
    case "Firebase: Error (auth/email-already-in-use).":
      message = Locale.t("account_already_exist");
      break;
    case "Firebase: Error (auth/too-many-requests).":
      message = Locale.t("try_after_some_time_or_check_mail");
      break;
    case "INVALID_EMAIL":
      message = Locale.t("invalid_emailId");
      break;
    case "Firebase: Error (auth/user-not-found).":
      message = Locale.t("account_not_exist");
      break;
    case "Firebase: Password should be at least 6 characters (auth/weak-password).":
      message = Locale.t("password_validation");
      break;

    default:
      message = Locale.t("invalid_credential");
      break;
  }
  return message;
};
